import { Slider } from '@mui/material'
import { styled } from '@mui/material/styles'

export const PrettoSlider = styled(Slider)({
	width: '90%',
	color: '#EFF0F2',
	height: 5,
	'& .MuiSlider-track': {
		border: 'none',
		backgroundColor: '#EFF0F',
	},
	'.MuiSlider-rail': {
		border: 'none',
		backgroundColor: '#EFF0F',
	},
	'& .MuiSlider-thumb': {
		height: 17,
		width: 17,
		backgroundColor: '#fff',
		border: '2px solid #7F7DF3',
		'&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
			boxShadow: 'inherit',
		},
		'&:before': {
			display: 'none',
		},
	},
})

export const PrettoSliderDark = styled(Slider)({
	width: '90%',
	height: 5,
	'& .MuiSlider-track': {
		border: 'none',
		backgroundColor: '#40404E',
	},
	'.MuiSlider-rail': {
		border: 'none',
		backgroundColor: '#40404E',
	},
	'& .MuiSlider-thumb': {
		height: 17,
		width: 17,
		backgroundColor: '#373737',
		border: '2px solid #7F7DF3',
		'&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {},
		'&:before': {
			display: 'none',
		},
	},
})
